import { ecoulementPct } from '../lib/lotsHelpers.js';

export default function EcoulementBadge({ sold, total }) {
  const pct = ecoulementPct(sold, total);
  const cls =
    pct >= 50
      ? 'bg-green-100 text-green-700'
      : pct >= 20
        ? 'bg-orange-100 text-orange-700'
        : 'bg-red-100 text-red-700';
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${cls}`}>
      {pct} %
    </span>
  );
}
